import { render, staticRenderFns } from "./onboarding_navbar.vue?vue&type=template&id=480f6fb6&scoped=true&"
import script from "./onboarding_navbar.vue?vue&type=script&lang=js&"
export * from "./onboarding_navbar.vue?vue&type=script&lang=js&"
import style0 from "./onboarding_navbar.vue?vue&type=style&index=0&id=480f6fb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480f6fb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('480f6fb6')) {
      api.createRecord('480f6fb6', component.options)
    } else {
      api.reload('480f6fb6', component.options)
    }
    module.hot.accept("./onboarding_navbar.vue?vue&type=template&id=480f6fb6&scoped=true&", function () {
      api.rerender('480f6fb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Navbar/onboarding_navbar.vue"
export default component.exports